import { render, staticRenderFns } from "./HomeTeleconsulto.vue?vue&type=template&id=2ccb0f18&"
import script from "./HomeTeleconsulto.vue?vue&type=script&lang=js&"
export * from "./HomeTeleconsulto.vue?vue&type=script&lang=js&"
import style0 from "./HomeTeleconsulto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports